import React, { memo } from 'react';
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from 'reactstrap';

import SimpleHeader from 'components/Headers/SimpleHeader.js';

const UPDATE_PACKAGES = [
  {
    id: 'mobile-20042026',
    title: 'Cập nhật mobile ngày 20/4/2026',
    platform: 'Android (APK)',
    releaseDate: '20/04/2026',
    fileName: 'app-release.apk',
    fileUrl: '/update/update_apk_20042026/app-release.apk',
    fileSize: '29.47 MB',
  },
];

function UpdateManagement() {
  return (
    <>
      <SimpleHeader />
      <Container className="mt--9" fluid>
        <Row>
          <Col>
            <Card className="mb-3">
              <CardHeader className="pb-2 d-flex justify-content-between rounded border-bottom align-items-center">
                <h3 className="mb-0">Quản lý bản cập nhật</h3>
                <Badge color="info">Mobile</Badge>
              </CardHeader>
              <CardBody>
                <p className="text-muted mb-0">
                  Tải file cập nhật ứng dụng mobile đang phát hành.
                </p>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          {UPDATE_PACKAGES.map((item) => (
            <Col xs="12" lg="6" key={item.id} className="mb-3">
              <Card className="h-100">
                <CardBody className="d-flex flex-column justify-content-between">
                  <div>
                    <h4 className="mb-2">{item.title}</h4>
                    <div className="text-muted mb-1">Nền tảng: {item.platform}</div>
                    <div className="text-muted mb-1">Ngày phát hành: {item.releaseDate}</div>
                    <div className="text-muted mb-1">Tệp: {item.fileName}</div>
                    <div className="text-muted mb-3">Kích thước: {item.fileSize}</div>
                  </div>
                  <div>
                    <Button
                      color="info"
                      tag="a"
                      href={item.fileUrl}
                      download={item.fileName}
                    >
                      Tải xuống
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
}

export default memo(UpdateManagement);
